// Library Methods
import { useMemo } from "react";

// Components
import Skeleton from "@mui/material/Skeleton";
import RLFastGraph from "./RLFastGraph/RLFastGraph";
import RLFastC40Graph from "./RLFastC40Graph/RLFastC40Graph";
import RLFastC20Graph from "./RLFastC20Graph/RLFastC20Graph";

// Constants
import { gridTypeEnums } from "src/constants/enums";

// Types
import { ChartSpotType } from "src/services/exams/types";

const DEFAULT_CONTAINER_SIZE = 312;

type VFScreeningChartType = {
  vfScreeningSpots: Array<ChartSpotType>;
  eyeType: string;
  gridType: string | undefined;
  isLiveUpdate?: boolean;
  containerSize?: number;
};

const VFScreeningChart = ({
  vfScreeningSpots,
  eyeType,
  gridType,
  isLiveUpdate = false,
  containerSize = DEFAULT_CONTAINER_SIZE,
}: VFScreeningChartType) => {
  const isC40 = useMemo(
    () => gridType === gridTypeEnums.G_C_40.type,
    [gridType]
  );

  const isC20 = useMemo(
    () => gridType === gridTypeEnums.G_C_20.type,
    [gridType]
  );

  // Show loading skeleton if data is not yet processed
  if (vfScreeningSpots?.length === 0) {
    return (
      <Skeleton
        variant="rounded"
        width="100%"
        height={DEFAULT_CONTAINER_SIZE}
        sx={{
          borderRadius: "4px",
        }}
      />
    );
  }

  if (isC40) {
    return (
      <RLFastC40Graph
        vfScreeningSpots={vfScreeningSpots}
        eyeType={eyeType}
        gridType={gridType}
        isLiveUpdate={isLiveUpdate}
        containerSize={containerSize}
      />
    );
  } else if (isC20) {
    return (
      <RLFastC20Graph
        vfScreeningSpots={vfScreeningSpots}
        eyeType={eyeType}
        gridType={gridType}
        isLiveUpdate={isLiveUpdate}
        containerSize={containerSize}
      />
    );
  }

  return (
    <RLFastGraph
      vfScreeningSpots={vfScreeningSpots}
      eyeType={eyeType}
      gridType={gridType}
      isLiveUpdate={isLiveUpdate}
    />
  );
};

export default VFScreeningChart;
